import { render } from "./PedidoCreado.vue?vue&type=template&id=c52eb40a"
import script from "./PedidoCreado.vue?vue&type=script&lang=js"
export * from "./PedidoCreado.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__